import { makeStyles } from '@material-ui/core/styles';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    minHeight: '95.96vh',
    minWidth: '97.51vw',
    maxWidth: '97.51vw',
    borderRadius: 'unset',
    backgroundColor: themeColor.lightBackground,
    overflowY: 'hidden',
  },
  container: {
    paddingTop: '2vh',
    backgroundColor: themeColor.lightgrey,
  },
  inputGridItem: {
    paddingBottom: '2.99vh',
  },
  digitalReceiptForm: {
    position: 'absolute',
    top: 0,
    left: 0,
    margin: 0,
    height: '100%',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'start',
    paddingTop: '13.44vh',
  },
  button: {
    fontSize: vh(2.08),
  },
  cancelButton: {
    lineHeight: 1.11,
    marginRight: '0.75vw',
  },
  endButton: {
    marginRight: '1.36vw',
  },
  contentContainer: {
    flex: '0 0 30.62vh',
  },
  header: {
    backgroundColor: themeColor.white,
    height: '9vh',
    fontSize: rem(1.125),
  },
  icon: {
    width: '1.75rem',
    height: '1.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1vw',
  },
  spacing: {
    marginLeft: '1vw',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  title: {
    display: 'inline-block',
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    letterSpacing: 0.43,
    fontSize: rem(2),
    marginBlockStart: 0,
    marginBlockEnd: '0',
    color: theme.palette.primary.main,
  },
  message: {
    lineHeight: '1.56',
    color: themeColor.blackish,
    fontSize: rem(1.125),
    marginBlockStart: 0,
    marginBlockEnd: 0,
    fontWeight: 500,
  },
  textContainer: {
    paddingBottom: '4vh',
  },
}));
